<template>
    <Breadcrumbs main="Blog" title="Add Post" />
    <div class="container-fluid">
        <div class="row">
            <addPost />
        </div>
    </div>
</template>
<script lang="ts" setup>
import { defineAsyncComponent } from 'vue';
const addPost = defineAsyncComponent(() => import("@/components/theme/blog/addpost/addPost.vue"))
</script>